<div class="col mx-2">
  <pos-app-spinner *ngIf="loadingDetailView$ | async"></pos-app-spinner>
  <app-lib-user-email-view
    *ngIf="!isExternalUser && !isProgrammeUser && internalEmailList.length > 0"
    [userEmailList]="internalEmailList"
    (selectedEmail)="showPIBEmailDetails($event)"
    [userSeletedEmailDetails]="internalEmailDetail"
    [title]="title"
    [loading]="loading$ | async"
  ></app-lib-user-email-view>
</div>
